import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
import { roleColumns } from './_columns'
import { useAuth } from '../../../../auth'

const UsersList = () => {
  const { itemIdForUpdate } = useListView()
  const { currentUser } = useAuth() as any;
  return (
    <KTCard>
      {currentUser?.userType !== "CLIENT" && <UsersListHeader placeholder='Search Sponsor' label='Add' />}
      <UsersTable columnProps={roleColumns} />
      <UserEditModal formName='MembershipModalForm' />
    </KTCard>
  )
}

const MembershipWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'sponsorship-packages' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { MembershipWrapper }
